import { useCallback, useEffect, useMemo, useState } from 'react';

import axiosApiInstance from '@/api/shared/axios-instance';
import { REDUCERS } from '@/constants/reducers';
import URL_FACTORY from '@/helpers/url-helper';

import useSpinner from '@/DesignSystem/hooks/useSpinner';
import CustomDrawer from '@/DesignSystem/components/drawer/CustomDrawer';
import JugadoresDrawerComponentHeader from '../common/JugadoresDrawerComponentHeader';
import CalendarioDelJugadorDrawerColumns from './CalendarioDelJugadorDrawerColumns';
import CustomTable, { CustomTableVariants } from '@/DesignSystem/components/custom-table';
import { notifyError } from '@/notifications/notify';
import PlacementModalComponent from '@/components/ads-components/placements/placementModal';

const CalendarioDelJugadorDrawer = ({ playerCalendar, dispatch }) => {
    const [open, setOpen] = useState(false);

    const [data, setData] = useState(null);
    const [cache, setCache] = useState([]); // Estado para la caché

    const { showSpinner, hideSpinner } = useSpinner();

    const handleClose = useCallback(() => {
        setOpen(false);
        setData(null);

        dispatch({
            type: REDUCERS.SHOW_PLAYER_CALENDAR,
            payload: null,
        });
    }, [dispatch]);

    useEffect(() => {
        if (playerCalendar > 0) {
            // Verificamos si el resultado está en la caché
            const isCached = cache.find((x) => x.playerCalendarId === playerCalendar);

            if (isCached) {
                setData(isCached.data);
                setOpen(true);
                return;
            }

            const payload = {
                playerId: playerCalendar,
            };

            showSpinner();

            // Si no está en la caché, hacemos la solicitud
            axiosApiInstance
                .post(URL_FACTORY.GetPlayerCalendar, payload)
                .then((response) => {
                    if (response?.data) {
                        setData(response.data);
                        setOpen(true);

                        // Agregamos el resultado a la caché
                        setCache((prevCache) => [
                            ...prevCache,
                            {
                                playerCalendarId: playerCalendar,
                                data: response.data,
                            },
                        ]);
                    }
                })
                .catch((_error) => {
                    notifyError('Error al obtener el calendario del jugador');
                })
                .finally(() => {
                    hideSpinner();
                });
        }
    }, [playerCalendar, cache]);

    const columns = useMemo(() => {
        return CalendarioDelJugadorDrawerColumns();
    }, []);

    const rows = useMemo(() => {
        return data?.fixtures?.map((partido, index) => ({
            ...partido,
            day: index + 1,
        }));
    }, [data]);

    if (!data) {
        return null;
    }

    return (
        <CustomDrawer open={open} onClose={handleClose} title="Calendario del jugador">
            {/* Contenido Principal */}
            <JugadoresDrawerComponentHeader
                id={data?.id}
                name={data?.name}
                teamId={data?.teamId}
                status={data?.status}
                statusLevel={data?.statusLevel}
                marketValue={data?.marketValue}
                subida={data?.subida}
                points={data?.points}
                averagePoints={data?.averagePoints}
                fitness={data?.fitness}
            />

            <PlacementModalComponent />

            <CustomTable
                columns={columns}
                rows={rows}
                variant={CustomTableVariants.WITHOUT_PAGINATION}
                tableSx={{ tableLayout: 'fixed' }}
                rowHeight={40}
            />
        </CustomDrawer>
    );
};

export default CalendarioDelJugadorDrawer;

// 275 lineas
